<template>
  <span
    v-if="issueStatus"
    class="h-4 shrink-0 rounded-[10px] px-2 font-proxima-nova text-[10px] font-medium leading-4"
    :class="issueStatusToTailwindMap[issueStatus]"
  >
    {{ issueStatus }}
  </span>
</template>

<script setup lang="ts">
import { HazardIssueStatus } from '@/features/hazards';

defineProps<{
  issueStatus?: HazardIssueStatus;
}>();

// Matches the badges in the event summary (`accordion__header__badge` in ewa-webtemplate.css).
const issueStatusToTailwindMap: Record<HazardIssueStatus, string> = {
  New: 'bg-indigo-600 text-white',
  Updated: 'bg-indigo-100 text-indigo-600',
};
</script>
